import React from "react";
import { UseFormReturn } from "react-hook-form";
import { FormField, FormItem, FormLabel, FormControl, FormMessage } from "@/components/ui/form";
import { Textarea } from "@/components/ui/textarea";
import { AgeGroupVariationFormData } from "../schemas/ageGroupVariationSchema";
import { useAuth } from "@/context/AuthContext";
import { ProgramLinkFields } from "./ProgramLinkFields";

interface AdditionalProgramFieldsProps {
  form: UseFormReturn<AgeGroupVariationFormData>;
}

export const AdditionalProgramFields: React.FC<AdditionalProgramFieldsProps> = ({ form }) => {
  const { isAdmin } = useAuth();

  return (
    <div className="space-y-4">
      <h3 className="text-lg font-medium">Additional optional information</h3>
      <p className="text-sm text-muted-foreground mb-4 text-left px-1">
        The following fields are optional and will be used as the default values for the session.
      </p>

      {/* Program description */}
      <FormField
        control={form.control}
        name="description"
        render={({ field }) => (
          <FormItem>
            <FormLabel>Description</FormLabel>
            <FormControl>
              <Textarea
                className="min-h-[80px]"
                maxLength={2000}
                {...field}
              />
            </FormControl>
            <div className="text-xs text-muted-foreground text-right mt-1">
              {field.value?.length || 0}/2000
            </div>
            <FormMessage />
          </FormItem>
        )}
      />

      {/* Eligibility notes */}
      <FormField
        control={form.control}
        name="eligibilityNotes"
        render={({ field }) => (
          <FormItem>
            <FormLabel>Eligibility notes</FormLabel>
            <FormControl>
              <Textarea
                className="min-h-[80px]"
                {...field}
              />
            </FormControl>
            <FormMessage />
          </FormItem>
        )}
      />

      <ProgramLinkFields form={form} legacyUrl={form.getValues("url")} />

      {/* Program data extraction URLs, notes (admin-only) */}
      {isAdmin && (
        <FormField
          control={form.control}
          name="dataFetchUrl"
          render={({ field }) => (
            <FormItem>
              <FormLabel>Program data extraction URLs, notes (admin-only)</FormLabel>
              <FormControl>
                <Textarea
                  placeholder="URLs for API endpoints, data fetching, notes for data automation..."
                  className="min-h-[80px]"
                  {...field}
                />
              </FormControl>
              <FormMessage />
            </FormItem>
          )}
        />
      )}
    </div>
  );
}; 